import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import type { Language } from './language';
import { initialLanguage, storeLanguage } from './language';
import { resources } from './resources';

/*
  Initialised synchronously at import — the resources are bundled, so there is
  nothing to wait for and the first render is already in the right language.
  `main.tsx` imports this module before rendering.
*/
void i18next.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: 'en',
  defaultNS: 'pmShell',
  returnEmptyString: false,
  interpolation: {
    // React escapes already.
    escapeValue: false,
  },
  initAsync: false,
});

const syncDocumentLanguage = (language: string): void => {
  if (typeof document !== 'undefined') document.documentElement.lang = language;
};
syncDocumentLanguage(i18next.language);
i18next.on('languageChanged', syncDocumentLanguage);

/** The picker's write: switch the UI (react-i18next re-renders) and remember it. */
export const setLanguage = (language: Language): void => {
  storeLanguage(language);
  void i18next.changeLanguage(language);
};

export { i18next as i18n };
